import { render } from "./AdultsSectionFive.vue?vue&type=template&id=226e6f6f&scoped=true"
import script from "./AdultsSectionFive.vue?vue&type=script&lang=js"
export * from "./AdultsSectionFive.vue?vue&type=script&lang=js"

import "./AdultsSectionFive.vue?vue&type=style&index=0&id=226e6f6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226e6f6f"]])

export default __exports__